module.exports = __webpack_public_path__ + "static/media/YM08_2.8c211fa9.jpg";